const api = {
  getUsers: 'Home/GetUsers',
  login: 'Home/Login',
  getuserinfo:'api/employee/user-info',
  getTemplate:"api/approval/template",
  startProcess:'api/approval/start-process',
  GetAccessToken:"api/file/file-upload",
  GetRelation:"api/employee",
  GetCategorys:"api/approval/categorys",
  GetFlowSetting:"api/approval/flow-setting",
  GetPersonalAllHonour:"api/BusinessCard/get-personal-all-honour",
  GetOtherInfoByTypeName:"api/BusinessCard/get-other-info-by-typename",
  GetFirstComplaintsHotline:"api/BusinessCard/get-first-complaints-hotline",
  QueryAddress:"api/BusinessCard/query-address"
};
export default api;